var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-dot"},[_c('span',{staticClass:"status-dot__dot",class:'status-dot__dot--' + _vm.status}),_c('span',{staticClass:"status-dot__label"},[_vm._v(_vm._s(_vm._label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }